import $ from 'jquery';

import Vars from '../../vars';
import Utils from "../../components/utils";
import Modal from "../../components/Modal";
import Request from "../../components/request";

class Document {
    constructor(args) {
        let self = this;

        self._setArgs(args);
        self._init();
    }

    _elems = {
        $modal : $(),
        $form  : $()
    };

    _const = {
        entities : 'documents',
        entity   : 'document',
        title : {
            edit : 'Редактирование документа'
        },
    };

    _args = {
        mode   : '',
        item   : {},
        object : {},
        done   : function(){}
    };

    _setArgs = (args) => {
        let self = this;

        self._args.mode   = args.mode;
        self._args.item   = args.item;
        self._args.object = args.object;
        self._args.done   = args.done || self._args.done;
    };

    _initModal = () => {
        let self = this;

        self._elems.$modal = new Modal({
            title   : self._const.title.edit,
            content : Utils.renderProfileTemplate(self._const.entity + '-form', {
                object               : self._args.object,
                [self._const.entity] : self._args.item
            }),
            closingConfirmation: true,
            confirm : function(args) {
                let $modal = args.modal;
                if (!$modal.length) return;
                let $form = $modal.find('form');
                if (!$form.length) return;

                Request.send({
                    path   : '/api/objects/' + self._args.object.id + '/buildings/' + self._const.entities + '/ ' + self._args.item.id + '/edit',
                    method : 'POST',
                    data   : $form.serialize(),
                    done   : function(response) {
                        loader.decrease();
                        if (response.error) {
                            //self.profile.callback.error(response.error, form);
                            return
                        }
                        self._args.done(response);
                        $modal.trigger('close');
                    }
                });
            }
        });
    };

    _building = () => {
        let self = this;

        self._initModal();
    };

    _init = () => {
        let self = this;

        if (self._args.mode == Vars.document.modes.building) {
            self._building();
        }
    }
}

export default Document;